import PropTypes from 'prop-types';
import { path, equals, assoc } from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import badgeData from '@wayfinder/vms-state/src/canonical-loader/badgeData.json';
import { TopBar } from '../../components';
import venueData from './data/venue-list.json';
import s from './HostStyles.module.scss';

const gateBadge = path(['gate', 0, 'dataUri'], badgeData);

const noop = () => {};
/*
 * Toggle state[field] between v1 and v2
 */
const toggle = (field, v1, v2, state) => {
    const v = equals(state[field], v1) ? v2 : v1;
    return assoc(field, v, state);
};

/*
 * Higher order container that wraps a TopBar; properties passed in are used to configure the TopBar
 * @see TopBarConfigurator for examples of how the ConfiguredTopBarHost is configured
 */
class ConfiguredTopBarHost extends Component {
    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        isV5: PropTypes.bool.isRequired,
        failedSaves: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    constructor(props) {
        super(props);

        // State modified by TopBar
        this.state = {
            venueId: 'sjc',
            selectedView: 'list',
        };

        this.onViewSelect = this.setItem('selectedView').bind(this);
        this.onVenueSelect = this.setItem('venueId').bind(this);
        this.onSelectFailedPoi = a => console.log('select failed poi id: ', a);
        this.onRetryFailures = () => console.log('retry all failed updates');
        this.onCancelAllUpdates = () => console.log('cancel all failed updates');
    }

    setItem = key => value => this.setState(state => assoc(key, value, state));

    render = () => {
        const topBarProps = {
            venueId: this.state.venueId,
            selectedView: this.state.selectedView,
            failedSaves: this.props.failedSaves,
            isSaving: this.props.isSaving,
            isV5: this.props.isV5,
            venueBadgeUrl: gateBadge,
            venueSummaries: venueData,
            onVenueSelect: this.onVenueSelect,
            onViewSelect: this.onViewSelect,
            onRetryFailures: this.onRetryFailures,
            onSelectFailedPoi: this.onSelectFailedPoi,
            onCancelAllUpdates: this.onCancelAllUpdates,
        };

        return (
            <div className={s.editor}>
                <TopBar {...topBarProps} />
            </div>
        );
    };
}

/*
 * UI component to configure the ConfiguredTopBarHost (which in turn displays the TopBar)
 * Checkboxes in the configurator control properties sent to ConfiguredTopBarHost
 */
class TopBarHost extends Component {
    constructor(props) {
        super(props);

        // (these values are all passed as configurations to ConfiguredTopBarHost)
        this.state = {
            isV5: true,
            isSaving: false,
            failedSaves: [],
        };
    }

    renderCheckbox = (label, field, v1, v2) => (
        <React.Fragment>
            <label>
                <input style={{ opacity: 1, margin: '5px' }} type="checkbox" checked={equals(this.state[field], v1)} onChange={() => this.setState(state => toggle(field, v1, v2, state))} />

                <span> {label}</span>
            </label>
            <br />
        </React.Fragment>
    );

    render = () => (
        <div>
            <ConfiguredTopBarHost {...this.state} {...this.props} />

            <div style={{ margin: '40px 10px 10px 10px' }}>OPTIONS </div>

            <form className={s.formHost} onSubmit={noop} style={{ margin: '10px' }}>
                {this.renderCheckbox('v5', 'isV5', true, false)}
                {this.renderCheckbox('saving', 'isSaving', true, false)}
                {this.renderCheckbox('failed saves', 'failedSaves', [{ id: '1', name: 'a' }], [])}
            </form>
        </div>
    );
}

const mapStateToProps = () => ({}); // just trying to get 'dispatch' -- which is added automatically

export default connect(mapStateToProps)(TopBarHost);
